import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NgxSpinnerService } from 'ngx-spinner';
import { PontoFidelidade } from 'src/app/models/ponto-fidelidade';
import { CarregandoService } from 'src/app/services/carregando.service';
import { FidelidadePontoService } from 'src/app/services/fidelidade-ponto.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-cadastrar-pontos-fidelidade-modal',
  templateUrl: './cadastrar-pontos-fidelidade-modal.component.html',
  styleUrls: ['./cadastrar-pontos-fidelidade-modal.component.scss']
})
export class CadastrarPontosFidelidadeModalComponent implements OnInit {

  idPonto;
  ponto: PontoFidelidade;
  public config: PerfectScrollbarConfigInterface = {};
  administrador = false;
  carregando = true;
  editando = false;
  regra;

  // construtor
  constructor(public dialogRef: MatDialogRef<CadastrarPontosFidelidadeModalComponent>, private globalService: GlobalService,
    @Inject(MAT_DIALOG_DATA) public data: any, private notificacaoService: NotificacaoService, private fidelidadePontoService: FidelidadePontoService,
    private spinner: NgxSpinnerService, private utilitarioService: UtilitarioService, private carregandoService: CarregandoService,) {
    this.idPonto = data.idPonto;
    this.regra = data.regra;
  }

  async ngOnInit() {

    this.administrador = await this.globalService.administrador();
    if (this.idPonto) {
      this.editando = true;
      this.buscarPontoFidelidade();
    } else {
      this.ponto = new PontoFidelidade();
      this.ponto.regra = this.regra;
    }
  }

  salvar() {
    if (this.ponto.pontos !== null && this.ponto.pontos !== undefined) {
      this.ponto.pontos = Number(this.ponto.pontos);
    }
    if (this.ponto.regra !== null && this.ponto.regra !== undefined) {
      this.ponto.regra = Number(this.ponto.regra);
    }
    if (this.ponto.inicio !== null && this.ponto.inicio !== undefined) {
      this.ponto.inicio = Number(this.ponto.inicio);
    }
    if (this.ponto.fim !== null && this.ponto.fim !== undefined) {
      this.ponto.fim = Number(this.ponto.fim);
    }
    if (this.ponto.validade !== null && this.ponto.validade !== undefined) {
      this.ponto.validade = Number(this.ponto.validade);
    }
    this.carregandoService.mostra('salvarPontoFidelidade');
    this.fidelidadePontoService.salvar(this.ponto).subscribe((retorno) => {
      this.notificacaoService.sucesso('Ponto salvo com sucesso!!!');
      this.carregandoService.esconde('salvarPontoFidelidade');
      this.dialogRef.close(true);
    }, (erro) => {
      this.carregandoService.esconde('salvarPontoFidelidade');
      this.notificacaoService.erro(erro);
    });
  }


  fechar() {
    this.dialogRef.close();
  }

  buscarPontoFidelidade() {
    this.carregandoService.mostra('buscarPontoFidelidade');

    this.fidelidadePontoService.consultarPorId(this.idPonto).subscribe((data: any) => {
      this.ponto = data;
      this.carregando = false;
      this.carregandoService.esconde('buscarPontoFidelidade');
    }, (erro) => {
      this.carregandoService.esconde('buscarPontoFidelidade');
      this.notificacaoService.erro(erro);
    });
  }

  validar() {
    return this.ponto.inicio !== null && this.ponto.inicio !== undefined &&
      this.ponto.fim !== null && this.ponto.fim !== undefined &&
      this.ponto.pontos !== null && this.ponto.pontos !== undefined &&
      this.ponto.validade !== null && this.ponto.validade !== undefined;
  }

}
